module.exports = __webpack_public_path__ + "img/left-2.4093458c.jpg";